import { useRef } from "react";

export function useDebounce(wait = 400, leading = false) {
  const timer = useRef(null);
  const func = useRef(null);

  const _clearTimer = () => {
    timer.current && clearTimeout(timer.current);
    timer.current = null;
  };

  return (newFunction, scope, args) => {
    if (leading === true) {
      func.current = newFunction;

      if (timer.current === null) func.current && func.current.apply(scope, args);

      _clearTimer();
      timer.current = setTimeout(() => _clearTimer(), wait);
    } else {
      _clearTimer();

      func.current = newFunction;

      timer.current = setTimeout(() => {
        func.current && func.current.apply(scope, args);
        _clearTimer();
      }, wait);
    }
  };
}
